export enum AggregationType {
  CountAggregation = 'CountAggregation',
  SumAggregation = 'SumAggregation',
}
